import { Component } from '@angular/core';

@Component({
  selector: 'pulse-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent {
  constructor() {}
}
